import axios from "axios";

const GATEWAY_BASE = process.env.REACT_APP_API_URL;
const SEND_TIMEZONE_HEADER = process.env.REACT_APP_SEND_TIMEZONE_HEADER === 'true';

const normalizeBaseUrl = (value?: string) => {
  if (!value) return 'http://localhost:8082';
  return value.endsWith('/') ? value.slice(0, -1) : value;
};

const withCoachingPrefix = (baseUrl: string) => {
  if (baseUrl.includes('/coaching/v1')) {
    return baseUrl;
  }
  if (baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1')) {
    return baseUrl;
  }
  return `${baseUrl}/coaching/v1`;
};

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: withCoachingPrefix(normalizeBaseUrl(GATEWAY_BASE)),
});

// Add request interceptor to include access token.
// Timezone header is opt-in to avoid unnecessary CORS preflight failures.
axiosInstance.interceptors.request.use(
  (config) => {
    if (SEND_TIMEZONE_HEADER) {
      config.headers['X-User-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let hasNotifiedDisconnect = false;

const notifyDisconnected = () => {
  if (hasNotifiedDisconnect || typeof window === 'undefined') {
    return;
  }
  hasNotifiedDisconnect = true;
  window.dispatchEvent(new Event('api-disconnected'));
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (!error?.response || [502, 503, 504].includes(status)) {
      notifyDisconnected();
    }
   
    return Promise.reject(error);
  }
);

// Create a separate axios instance for core-backend endpoints (like profile upload)
export const coreBackendAxios = axios.create({
  withCredentials: true,
  baseURL: normalizeBaseUrl(GATEWAY_BASE), // Use raw base URL without /coaching/v1 prefix
});

// Request interceptor handled dynamically by ClerkAxiosInterceptor

coreBackendAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (!error?.response || [502, 503, 504].includes(status)) {
      notifyDisconnected();
    }
   
    return Promise.reject(error);
  }
);

export default axiosInstance;
